var React = require('react');

function PlayIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"Dribbble-Light-Preview","transform":"translate(-427.000000, -3765.000000)","fill":"#000000"},React.createElement("g",{"id":"icons","transform":"translate(56.000000, 160.000000)"},React.createElement("polygon",{"id":"play-[#1001]","points":"371 3605 371 3613 378 3609"})))));
}

PlayIcon.defaultProps = {"width":"800px","height":"800px","viewBox":"-0.5 0 8 8","version":"1.1"};

module.exports = PlayIcon;

PlayIcon.default = PlayIcon;
